import { h } from 'preact';
import React, { Component } from 'react';

import { ColumnSettings } from './ColumnSettings';
import Children from '../../messages/Notice/Children';

import './Column.css';

export class Column extends Component {
  render() {
    const Settings = new ColumnSettings(this.props.component.settings);

    const styles = {
      ...Settings.padding,
      ...Settings.margin,
      ...Settings.border
    };

    /* WIDTH & HEIGHT */
    const { paddingTop, paddingBottom } = Settings.padding; 
    const { marginTop, marginBottom } = Settings.margin; 
    styles.width = Settings.width.type === 'auto' ? 'auto' : Settings.width.value+Settings.width.type;
    styles.height = Settings.height.type === 'auto' ? 'auto' : Settings.height.value+Settings.height.type;
    if ( Settings.height.type === '%' ) {
      styles.height = `calc(${Settings.height.value}% - ${(paddingTop+paddingBottom+marginTop+marginBottom)}px`
    }

    /* OTHER SETTINGS */
    styles.background = Settings.background;
    styles.alignItems = Settings.align;
    styles.justifyContent = Settings.vertical;

    /* DEV MODE ONLY */
    let devActions = {}, devClass = '', path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      if (!this.props.dev.opts.hideRowColumnBorders) devClass += ' on-dev';
      if (this.props.dev.current === path) devClass += ' on-active';
      if (this.props.component.children.length === 0) styles.minHeight = '24px';
    }

    return (
      <div className={'message-component message-column' + devClass} path={path} style={styles} {...devActions}>
        {Children({
          path: this.props.path,
          dev: this.props.dev,
          components: this.props.component.children,
          siteId: this.props.siteId,
          message: this.props.message,
          makeChoice: this.props.makeChoice,
          events: this.props.events
        })}
      </div>
    );
  }
}